import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "absolute top-0 w-full flex justify-between p-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h-2 w-2 bg-white rounded-full" }, null, -1)
const _hoisted_3 = { class: "text-xs font-semibold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute bottom-0 z-10 h-full w-full",
  style: {"background":"linear-gradient(0, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 75%)"}
}, null, -1)
const _hoisted_5 = {
  key: 0,
  style: {"box-shadow":"inset 0 0 0 1000px rgba(0, 0, 0, 0.5)"},
  class: "absolute inset-0 z-10 flex items-center justify-center"
}

import { computed, PropType, ref } from 'vue';
import dayjs from 'dayjs';
import { getSeriesDescription } from '@/helpers/series.helper';
import { ImageSeries } from '@/models';
import { BaseButton } from '@/lib/components/Button';
import { BaseIcon } from '@/lib/components/Icon';
import { LoadingIcon } from '@/lib/components/Loading';
import { ZephyrImageService } from '@/services/api';
import { i18n } from '@/i18n/i18n';
import { MeniconImageDetails, MeniconImageDetailsScore } from '@/custom/menicon/models';
import { MedKitBadge } from '@bigpicturemedical/medkit';


export default /*#__PURE__*/_defineComponent({
  __name: 'StudyGalleryItem',
  props: {
  imageSeries: {
    type: Object as PropType<ImageSeries>,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  signs: {
    type: Array,
    default: () => []
  },
  score: {
    type: Object as PropType<MeniconImageDetails['scoringDetails']>,
    default: null
  },
  scanHoverMessage: {
    type: String,
    default() {
      return i18n.global.t('platform.scans.open-in-viewer');
    }
  },
  hoverClass: {
    type: String,
    default: 'shadow-lg'
  }
},
  setup(__props) {

const props = __props;

const hover = ref(false);
const zephyrImageService = new ZephyrImageService();

const description = computed(() => getSeriesDescription(props.imageSeries));
const thumbnailUri = computed(() => {
  const image = props.imageSeries.images.find((image) => image.thumbnailUri);
  if (image) {
    return image.thumbnailUri;
  } else if (props.imageSeries.images.length) {
    const route = zephyrImageService.getEndpointUrl();
    return `${route}/${props.imageSeries.images[0].id}?lossy=1`;
  }
  return null;
});
const formatDate = (date: string) => dayjs(date).format('MMM D, YYYY h:mma');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center justify-center relative cursor-pointer bg-cover bg-no-repeat bg-center bg-gray-900 rounded-lg overflow-hidden text-white relative", hover.value ? __props.hoverClass : '']),
    style: _normalizeStyle(`background-image: url('${thumbnailUri.value}');${
      hover.value ? 'box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.5)' : ''
    }`),
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (hover.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hover.value = false))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-row space-x-3 items-center transition ease-in duration-150", hover.value ? 'opacity-25' : 'opacity-1']),
        style: _normalizeStyle(__props.signs.length ? '' : 'visibility: collapse')
      }, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('custom.uhb.scans.sign.number', [__props.signs.length])), 1)
      ], 6),
      (__props.imageSeries.inadequacies && __props.imageSeries.inadequacies.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([hover.value ? 'opacity-50' : 'opacity-1', "flex items-center py-1.5 px-2 space-x-2 text-black bg-alert-500 rounded mb-2 text-xs font-semibold"])
          }, [
            _createVNode(_unref(BaseIcon), { name: "inadequate" }),
            _createTextVNode(),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('custom.uhb.scans.inadequate')), 1)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-col absolute bottom-0 left-0 z-20 m-6 text-xs font-regular transition ease-in duration-75 space-y-1", hover.value ? 'opacity-25' : 'opacity-1'])
    }, [
      (__props.score)
        ? (_openBlock(), _createBlock(_unref(MedKitBadge), {
            key: 0,
            label: __props.score.topographyDataScore === _unref(MeniconImageDetailsScore).UNKNOWN ?
          _ctx.$t('custom.menicon.scans.score.Unknown') : `${__props.score.scorePercentage}%`,
            kind: "stable",
            size: "tiny"
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(description.value), 1),
      _createElementVNode("span", null, _toDisplayString(formatDate(__props.imageSeries.seriesDate)), 1)
    ], 2),
    _createVNode(_unref(BaseButton), {
      class: _normalizeClass(["text-white bg-transparent text-sm font-medium z-20 transition duration-150", hover.value ? 'opacity-1 top-0' : 'opacity-0 top-10']),
      "left-icon": "add",
      color: "muted",
      size: "small"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.scanHoverMessage), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _hoisted_4,
    (__props.loading && !hover.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_unref(LoadingIcon))
        ]))
      : _createCommentVNode("", true)
  ], 38))
}
}

})